import { UserCertificateDto } from "./da-cert.type";
import { RatingDto } from "./rating.type";

export interface AccessTokenData {
  name: string;
  role: string;
  exp: number;
  iat: number;
  jti: number;
  nbf: number;
}

export interface UserClaims {
  sub: number;
  email: string;
  firstName: string;
  lastName: string;
  role: string;
  practiceId?: number;
  isWizardComplete: boolean;
  profileImgUrl: string;
}

export interface EmployeeDto {
  id: number;
  profileImageUrl: string;
  firstName: string;
  lastName: string;
  initials: string;
  rating: number;
  isBlocked: boolean;
  isFavorite: boolean;
  positions: string[];
}

export interface DashboardUserDto {
  id: number;
  userName: string | null;
  firstName: string | null;
  lastName: string | null;
  roleName: string | null;
}

export interface UserDetailDto {
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  positions: string;
  profileImageUrl: string;
  rating: number;
  isFavorite: boolean;
  ratingHistory: RatingDto[];
  certificates: UserCertificateDto[];
}

export class UserFormDto {
  firstName = "";
  lastName = "";
  email = "";
  phoneNumber = "";
  password = "";
  officeId: number | null = null;
}

export class UserProfileFormDto {
  id = 0;
  firstName: string | null = null;
  lastName: string | null = null;
  email: string | null = null;
  userName: string | null = null;
  phoneNumber: string | null = null;
  profileData: string | null = null;
  profileUrl: string | null = null;
  smsEnabled = false;
}

export class LoginFormDto {
  userName = "";
  password: string | null = null;
}

export class RegisterFormDto {
  firstName = "";
  lastName = "";
  email = "";
  password = "";
  phoneNumber = "";
}

export class ResetPasswordFormDto {
  email = "";
  token: string | null = null;
  password: string | null = null;
}